import { useRouter } from "next/router";
import { UseFormReturn, useWatch } from "react-hook-form";

import useProductQuery from "../../hooks/services/useProductQuery";
import { ProductListFilter } from "../../types/product";
import PageNav from "../reuseables/pageNav.comp";

export default function ProductListPaging({ methods }: { methods: UseFormReturn<ProductListFilter, any> }) {
  const router = useRouter();
  const [pageSize] = useWatch({
    control: methods.control,
    name: ["pageSize"],
  });
  const { data: products } = useProductQuery(methods);

  const total = products?.size;

  //  @ts-ignore
  return <PageNav page={Number(router.query.page) || 1} size={pageSize} total={total} pathname="/" query={router.query} />;
}
